require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/core-js@2.6.12/~/core-js/library/modules/es7.symbol.async-iterator.js
// module id = kQFN
// module chunks = 5